import { createContext, useContext, useState } from 'react';

export const LocalStorageContext = createContext({});

export const useLocalStorageContext = (key) => {
  const context = useContext(LocalStorageContext);

  if (!context[key]) {
    throw new Error(`Key "${key}" not initialized in LocalStorageContext`);
  }
  return context[key];
};

export const LocalStorageFallbackProvider = ({ children }) => {
  // This state object will store state for each unique key used with useLocalStorage.
  const [storage, setStorage] = useState({});

  const setKeyState = (key, newState) => {
    setStorage((prevStorage) => ({
      ...prevStorage,
      [key]: newState
    }));
  };

  // We're providing both the storage object (contains state for all keys)
  // and a function to update state for a specific key.
  return <LocalStorageContext.Provider value={{ storage, setKeyState }}>{children}</LocalStorageContext.Provider>;
};
